export default {
  buttons: {
    sign_in: 'Conectează-te',
    sign_up: 'Înregistrează-te',
    logout: 'Deconectează-te',
  },
  logout_confirm: {
    title: 'Deconectare?',
    description: 'Ești sigur că vrei să te deconectezi?',
    cancel: 'Anulează',
    confirm: 'Deconectează-te',
  },
};
